App.controller('ConsentCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'profileService', '$filter', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, profileService, $filter) {
    $scope.page = 'profile';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Wyrażone zgody';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.profile';
    $scope.$emit('link', $scope.link);

    profileService.consentList($scope.data).then(function (data) {
        if (data.status === 200) {
            $scope.consents = data.data.consents;
        }
    });

    $scope.edit = function() {
        profileService.consentEdit({
            consents: $scope.consents,
            userId: JSON.parse(window.sessionStorage.getItem('userObject')).id
        }).then(function (data) {
            if (data.status === 200) {
                $scope.showPopUp('', 'Dane zmieniono pomyślnie', 'Wprowadzone dane zostały zapisane pomyślnie.', 'Wróć do profilu', 'root.home.profile');
            } else {
                $scope.showPopUp('', 'Zmiany nie zapisane', 'Nie udało się zapisać zmian.', '', '');
            }
        });
    }

    $scope.showPopUp = function(ev, head, content, text, target) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {
            
        }, function() {
            
        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
}]);